import * as types from './action-types';
import {getAppsByIdMap, getPendingApps, removePendingApp} from '../services/market-api';
import * as AppMarketSdk from '../services/wrapped-app-market-sdk';
import {getClientState} from '../config';
import {execBI} from '../services/bi-events-manager';
import _ from 'lodash';

export function receiveApps(appsType, json) {
  return {
    type: types.RECEIVE_APPS_BY_TYPE,
    appsType,
    items: json ? json.map(app => app) : [],
    receivedAt: json ? Date.now() : 0
  };
}

export function requestApps(appsType) {
  return {
    type: types.REQUEST_APPS_BY_TYPE,
    appsType
  };
}

export function fetchDeveloperIfNeeded(ids) {
  return (dispatch, getState) => {
    const state = getState();
    const developer = state.appsByType.developer;

    if (!developer.receivedAt) {
      dispatch(requestApps('developer'));

      return getAppsByIdMap(ids, state.mode.lang)
        .then(json => dispatch(receiveApps('developer', json)))
        .catch(() => dispatch(receiveApps('developer')));
    }
  };
}

export function fetchSingleIfNeeded(ids) {
  return (dispatch, getState) => {
    const state = getState();
    const single = state.appsByType.single;

    if (!single.receivedAt) {
      dispatch(requestApps('single'));

      return getAppsByIdMap(ids, state.mode.lang)
        .then(json => dispatch(receiveApps('single', json)))
        .catch(() => dispatch(receiveApps('single')));
    }
  };
}

export function fetchPendingIfNeeded() {
  return (dispatch, getState) => {
    const state = getState();
    const pIds = state.appsByType.pendingInMarket.items.map(i => i.guid);

    if (!state.appsByType.pending.receivedAt && state.appsByType.pendingInMarket.items.length) {
      dispatch(requestApps('pending'));

      return getAppsByIdMap(pIds, state.mode.lang)
        .then(json => dispatch(receiveApps('pending', json)))
        .catch(() => dispatch(receiveApps('pending')));
    }
  };
}

export function fetchPendingInMarketIfNeeded() {
  return (dispatch, getState) => {
    const state = getState();

    if (!state.mode.query.metaSiteId) {
      return;
    }

    if (!state.appsByType.pendingInMarket.receivedAt) {
      dispatch(requestApps('pendingInMarket'));

      return getPendingApps(state.mode.query.metaSiteId)
        .then(json => dispatch(receiveApps('pendingInMarket', json)))
        .catch(() => dispatch(receiveApps('pendingInMarket')));
    }
  };
}

export function fetchMyAppsIfNeeded() {
  return (dispatch, getState) => {
    const state = getState();
    const myAppsInMetaSite = state.mode.metaSiteApps.items
        .filter((app) => app.embeddedServiceType === 'ThirdPartyApps')
        .map((app) => app.clientSpec.appDefinitionId);

    if (!state.appsByType.myApps.receivedAt && myAppsInMetaSite.length) {
      dispatch(requestApps('myApps'));

      return getAppsByIdMap(myAppsInMetaSite.slice(0, 40), state.mode.lang) // limit to 40 because api url gets too long
        .then(json => dispatch(receiveApps('myApps', json)))
        .catch(() => dispatch(receiveApps('myApps')));
    }
  };
}

export function removePendingInMarketApp(app) {
  return (dispatch, getState) => {
    const state = getState();

    const pendingInMarket = state.appsByType.pendingInMarket.items;
    const pending = state.appsByType.pending.items;
    const pendingApp = _.find(pendingInMarket, i => i.guid === app.appDefinitionId);

    AppMarketSdk.removePendingApp(app.appDefinitionId);

    dispatch(receiveApps('pendingInMarket', pendingInMarket.filter(i => i.guid !== app.appDefinitionId)));
    dispatch(receiveApps('pending', pending.filter(i => i.appDefinitionId !== app.appDefinitionId)));

    execBI('PENDING_REMOVE_CLICK', {app_id: app.appDefinitionId});
    if (pendingApp && pendingApp.reasons.indexOf('Premium') === -1) {
      removePendingApp(state.mode.query.metaSiteId, app.appDefinitionId)
        .then(() => execBI('PENDING_REMOVE_DONE', {app_id: app.appDefinitionId}));
    }
  };
}

export function removePendingInMarketAfterInstall(app) {
  const state = getClientState();

  const pendingInMarket = state.appsByType.pendingInMarket.items;
  const pendingApp = _.find(pendingInMarket, i => i.guid === app.appDefinitionId);

  AppMarketSdk.removePendingApp(app.appDefinitionId);

  if (pendingApp && pendingApp.reasons.indexOf('Premium') === -1) {
    return removePendingApp(state.mode.query.metaSiteId, app.appDefinitionId)
      .then(() => true)
      .catch(() => true);

  } else {
    return Promise.resolve(true);
  }
}



// WEBPACK FOOTER //
// ./actions/apps-by-type.js